<template>
	<v-container>
		<v-card class="mb-4" flat outlined>
			<v-card-title>Contribuyente</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.rut">
						<label for="rut">Rut</label>
						<v-text-field
							id="rut"
							:value="`${contribuyente.rut}-${contribuyente.dv}`"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.razon_social">
						<label for="razon_social">Razón Social</label>
						<v-text-field
							id="razon_social"
							v-model="contribuyente.razon_social"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.nombres">
						<label for="nombres">Nombres</label>
						<v-text-field
							id="nombres"
							v-model="contribuyente.nombres"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.apellido_paterno">
						<label for="apellido_paterno">Apellido Paterno</label>
						<v-text-field
							id="apellido_paterno"
							v-model="contribuyente.apellido_paterno"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.apellido_materno">
						<label for="apellido_materno">Apellido Materno</label>
						<v-text-field
							id="apellido_materno"
							v-model="contribuyente.apellido_materno"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.giro">
						<label for="giro">Giro</label>
						<v-text-field
							id="giro"
							v-model="contribuyente.giro"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.actividad_economica">
						<label for="actividad_economica">Actividad Económica</label>
						<v-text-field
							id="actividad_economica"
							v-model="contribuyente.actividad_economica"
							solo
							readonly
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<v-card class="mb-4" flat outlined v-if="!!contribuyente.telefono || !!contribuyente.email || !!contribuyente.direccion || !!contribuyente.comuna">
			<v-subheader>Contacto</v-subheader>
			<v-card-text>
				<v-row>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.telefono">
						<label for="telefono">Teléfono</label>
						<v-text-field
							id="telefono"
							v-model="contribuyente.telefono"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.email">
						<label for="email">Correo Electrónico</label>
						<v-text-field
							id="email"
							v-model="contribuyente.email"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.direccion">
						<label for="direccion">Dirección</label>
						<v-text-field
							id="direccion"
							v-model="contribuyente.direccion"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.comuna">
						<label for="comuna">Comuna</label>
						<v-text-field
							id="comuna"
							v-model="contribuyente.comuna"
							solo
							readonly
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<!-- <v-card class="mb-4" flat outlined>
			<v-subheader>Resolución</v-subheader>
			<v-card-text>
				<v-row>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.fecha_resolucion">
						<label for="fecha_resolucion">Fecha Resolución</label>
						<v-text-field
							id="fecha_resolucion"
							v-model="contribuyente.fecha_resolucion"
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!(typeof contribuyente.numero_resolucion !== 'number' || !!contribuyente.numero_resolucion)">
						<label for="numero_resolucion">Número Resolución</label>
						<v-text-field
							id="numero_resolucion"
							v-model="contribuyente.numero_resolucion"
							solo
							readonly
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card> -->
		<v-card class="mb-4" flat outlined>
			<v-subheader>Autorización</v-subheader>
			<v-card-text>
				<v-row>
					<!-- <v-col cols="12" sm="12" md="6" v-if="!!contribuyente.autoriza">
						<label for="autoriza">Estado Autorizado</label>
						<v-text-field
							id="autoriza"
							v-model="contribuyente.autoriza"
							solo
							readonly
						></v-text-field>
					</v-col> -->
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.fecha_autorizacion">
						<label for="fecha_autorizacion">Fecha Autorización</label>
						<v-text-field
							id="fecha_autorizacion"
							:value=fechaAutorizacion
							solo
							readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="!!contribuyente.fecha_desautorizacion">
						<label for="fecha_desautorizacion">Fecha Desautorización</label>
						<v-text-field
							id="fecha_desautorizacion"
							:value=fechaDesautorizacion
							solo
							readonly
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'InformacionContribuyente',
	props: {
		contribuyente: {
			type: Object, // String, Number, Boolean, Function, Object, Array
			default: function(){
				return {
					rut: undefined,
					dv: undefined,
					razon_social: undefined,
					giro: undefined,
					actividad_economica: undefined,
					telefono: undefined,
					email: undefined,
					direccion: undefined,
					comuna: undefined,
					fecha_resolucion: undefined,
					numero_resolucion: undefined,
					nombres: undefined,
					apellido_paterno: undefined,
					apellido_materno: undefined,
					autoriza: undefined,
					fecha_autorizacion: undefined,
					fecha_desautorizacion: undefined,
				}
			}
		}
	},
	computed:{
		fechaDesautorizacion(){

			const contribuyente = this.contribuyente || {};

			let fecha = contribuyente.fecha_desautorizacion || null;

			return fecha;
		},
		fechaAutorizacion(){
			
			const contribuyente = this.contribuyente || {};

			let fecha = contribuyente.fecha_autorizacion || null;

			return fecha;
		},
	},
	data () {
		return {

		}
	},
	methods:{
	}
}
</script>

<style lang="css" scoped>
</style>